export default function ZRangeHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden w-full">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="/images/ai-futuristic-space-capsule-pod-luxury-acco-255379.webp"
          alt="Z Series Space Capsule"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-40 pb-20 w-full">
        {/* Badge */}
        <div className="inline-flex items-center gap-3 px-6 py-3 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-8">
          <div className="w-8 h-8 bg-cyan-500/20 rounded-full flex items-center justify-center">
            <span className="text-lg font-bold text-cyan-400">Z</span>
          </div>
          <span className="text-cyan-400 text-sm uppercase tracking-widest">Z Series</span>
        </div>

        {/* Main Title */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-thin mb-6 leading-tight">
          Future Living
          <br />
          <span className="text-cyan-400">Capsules</span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl sm:text-2xl lg:text-3xl text-gray-300 mb-12 max-w-4xl mx-auto font-light">
          Space capsule–style living units designed for luxury accommodation and immersive stay experiences
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <a 
            href="#models"
            className="px-8 py-4 bg-cyan-500 text-black text-base font-medium rounded-full hover:bg-cyan-400 transition-all hover:shadow-[0_0_30px_rgba(0,217,255,0.6)] whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
          >
            Explore Models
          </a>
          <a 
            href="#scenarios"
            className="px-8 py-4 bg-transparent border-2 border-cyan-500 text-cyan-400 text-base font-medium rounded-full hover:bg-cyan-500/10 transition-all whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
          >
            View Applications
          </a>
        </div>

        {/* Key Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-20 max-w-5xl mx-auto">
          <div className="text-center">
            <div className="text-4xl lg:text-5xl font-thin text-cyan-400 mb-2">360°</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">Panoramic Views</div>
          </div>
          <div className="text-center">
            <div className="text-4xl lg:text-5xl font-thin text-cyan-400 mb-2">15-25㎡</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">Living Space</div>
          </div>
          <div className="text-center">
            <div className="text-4xl lg:text-5xl font-thin text-cyan-400 mb-2">Smart</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">AI Control</div>
          </div>
          <div className="text-center">
            <div className="text-4xl lg:text-5xl font-thin text-cyan-400 mb-2">Premium</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider">Hospitality</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-cyan-400/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-cyan-400 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}